export default __webpack_public_path__ + "static/media/icono-2.58c74e60.jpg";